<template>
  <div class="node" id="node">
    <div class="title">
      <h2>{{ $t('node.p1') }}<span class="gold-text">{{ $t('node.p2') }}</span> </h2>
      <p>{{ $t('node.p3') }}</p>
    </div>
    <div class="n-c">
      <div class="img-box">
        <div class="status">{{ $t('node.p4') }}</div>
        <img src="@/assets/img/node/book.png">
        <div class="mask"></div>
      </div>
      <div class="form">
        <div class="form-t">
          <div class="f-t-l">
            <p>{{ $t('node.p5') }}</p>
            <span><i class="el-icon-location-outline"></i> Singapore</span>
          </div>
          <div class="f-t-r">
            <p class="gold-text">800 USDC</p>
            <p class="p2">{{ $t('node.p6') }}</p>
          </div>
        </div>
        <div class="prog">
          <div class="pr-1">
            <span class="pr-1-l"><i class="el-icon-user"></i>{{ $t('node.p7') }}</span>
            <span class="pr-1-r">{{ maxAmount - leftAmount }} / {{ maxAmount }}</span>
          </div>
          <div class="pr-2">
            <el-progress :percentage="((maxAmount - leftAmount) / maxAmount) * 100" :color="customColor" :text-inside="true"
              define-back-color="#002fa74d" :stroke-width="8"></el-progress>
          </div>
          <div class="pr-3">{{ $t('node.p8') }}{{ leftAmount }} {{ $t('node.p9') }}</div>
        </div>
        <div class="pay-types">
          <div class="p-t-t">{{ $t('node.p10') }}</div>
          <div class="py-item" :class="{ active: buyType === 0 }" @click="buyType = 0">
            <span>{{ baseUsdcPrice }} USDC</span>
            <i class="el-icon-check" v-if="buyType === 0"></i>
          </div>
          <div class="py-item" :class="{ active: buyType === 1 }" @click="buyType = 1">
            <span>{{ baseUsdcPrice * 0.75 }} USDC + {{ parseFloat(((baseUsdcPrice * 0.25) / otmPrice).toFixed(4)) }}
              OTM</span>
            <i class="el-icon-check" v-if="buyType === 1"></i>
          </div>
        </div>
        <div class="buy-amount">
          <span>{{ $t('node.p11') }}</span>
          <div class="num-input">
            <div class="n-i-i">
              <div class="btn reduce" :class="{ disabled: buyAmount <= 1 }" @click="buyAmount > 1 ? buyAmount-- : ''">
                <i class="el-icon-minus"></i>
              </div>
              <div class="num">{{ buyAmount }}</div>
              <div class="btn increase" :class="{ disabled: buyAmount >= 50 }"
                @click="buyAmount < 50 ? buyAmount++ : ''">
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <div class="des">{{ $t('node.p12') }}</div>
          </div>
        </div>
        <div class="sum">
          <span>{{ $t('node.p13') }}</span>
          <div class="sum-price">
            <div class="gold-text">{{ usdcCost }} USDC</div>
            <div v-if="buyType === 1" class="otm">+ {{ otmCost }} OTM</div>
          </div>
        </div>
        <div class="inviter-box">
          <div class="in-text">邀请人</div>
          <input type="text" class="inviter-input" :disabled="inputDisabled" v-model="inviter" />
        </div>
        <div class="bot-btn" @click="buy">
          <span v-if="walletAddress"><i class="el-icon-shopping-cart-2"></i>{{ $t('node.p14') }}</span>
          <span v-else>{{ $t('node.p15') }}</span>
        </div>
      </div>

    </div>
    <div class="b-list">
      <div class="l-item">
        <div class="t1">21</div>
        <div class="t2">{{ $t('node.p16') }}</div>
      </div>
      <div class="l-item">
        <div class="t1 tt1">42,000</div>
        <div class="t2">NFT {{ $t('node.p17') }}</div>
      </div>
      <div class="l-item">
        <div class="t1 gold-text">2,000</div>
        <div class="t2">{{ $t('node.p18') }}</div>
      </div>
      <div class="l-item">
        <div class="t1">50</div>
        <div class="t2">{{ $t('node.p19') }}</div>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="100%" center>
      <div class="dia-c">
        <div class="d-c-title">{{ $t('node.p20') }}</div>
        <div class="sub-t">{{ $t('node.p21') }}</div>
        <div class="buy-info">
          <div class="line">
            <span class="l-l">{{ $t('node.p22') }}</span>
            <span class="l-r gold">{{ $t('node.p23') }} (Singapore)</span>
          </div>
          <div class="line">
            <span class="l-l">{{ $t('node.p24') }}</span>
            <span class="l-r white">{{ buyAmount }} {{ $t('node.p25') }}</span>
          </div>
          <div class="line">
            <span class="l-l">{{ $t('node.p26') }}</span>
            <span class="l-r white">{{ buyType === 0 ? ($t('node.p27') + ' USDC') : 'USDC + OTM' }} </span>
          </div>
          <div class="line b-l">
            <span class="l-l">{{ $t('node.p28') }}</span>
            <div class="l-r">
              <div class="gold-text">{{ usdcCost }} USDC</div>
              <div class="otm" v-if="buyType === 1">+ {{ otmCost }} OTM</div>
            </div>
          </div>
        </div>
        <div class="m-info">{{ $t('node.p29') }}</div>
        <div class="btns">
          <div class="btn" @click="dialogVisible = false">{{ $t('node.p30') }}</div>
          <div class="btn btn-buy" @click="confirmBuy">
            <span v-if="!buyStatus">{{ $t('node.p31') }}</span>
            <span v-else-if="buyStatus === 'approving'"><i class="el-icon-loading"></i> {{ $t('node.p32') }}</span>
            <span v-else-if="buyStatus === 'minting'"><i class="el-icon-loading"></i> {{ $t('node.p34') }}</span>
          </div>
        </div>
        <div class="des">{{ $t('node.p35') }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { balance, allowance, approve } from '@/common/contractJs/token'
import { getOTMPrice, mint, inviterMap, getLEFT_AMOUNT, getMAX_AMOUNT } from '@/common/contractJs/mint'
import wallet from '@/common/wallet'
import { mapState } from 'vuex';
import { ethers } from "ethers";
import { formatTimes3 } from '@/common/utils'

const BSC_CONFIG = wallet.BSC_CONFIG
const CURRENT_NETWORK = wallet.CURRENT_NETWORK
const config = BSC_CONFIG[CURRENT_NETWORK]
export default {
  name: 'Node',
  data() {
    return {
      buyType: 0,
      buyAmount: 1,
      customColor: '#d1a84b',
      dialogVisible: false,
      baseUsdcPrice: 800,
      usdcBalance: 0,
      otmBalance: 0,
      usdcAllowance: 0,
      otmAllowance: 0,
      otmPrice: 0.02,
      timeInterval: null,
      buyStatus: '',
      inviter: '',
      storageList: [],
      leftAmount: 1,
      maxAmount: 1,
      inputDisabled: false
    }
  },
  computed: {
    ...mapState(['walletAddress', 'urlInviterAddress']),
    usdcCost() {
      const cost = this.buyType === 0 ? (this.baseUsdcPrice * this.buyAmount) : (this.baseUsdcPrice * this.buyAmount * 0.75)
      return parseFloat(cost.toFixed(4))
    },
    otmCost() {
      const cost = this.buyType === 0 ? 0 : (this.baseUsdcPrice * this.buyAmount * 0.25 / this.otmPrice)
      return parseFloat(cost.toFixed(4))
    },
  },
  watch: {
    walletAddress(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.getTokenInfo()
      }
    }
  },
  created() {
    this.init()
    let historyJson = localStorage.getItem('rwabs_mint_history_v101')
    this.storageList = historyJson ? JSON.parse(historyJson) : []
    // this.stakingList = this.storageList.filter(i => i.address === this.address).reverse()
  },
  beforeDestroy() {
    clearInterval(this.timeInterval)
  },
  methods: {
    init() {
      getOTMPrice().then(res => this.otmPrice = res)
      if (this.timeInterval) clearInterval(this.timeInterval)
      this.timeInterval = setInterval(() => {
        getOTMPrice().then(res => this.otmPrice = res)
      }, 10000)
      getLEFT_AMOUNT().then(res => this.leftAmount = res)
      getMAX_AMOUNT().then(res => this.maxAmount = res)
    },
    getTokenInfo() {
      balance(config.usdcAddress).then(res => this.usdcBalance = res)
      balance(config.otmAddress).then(res => this.otmBalance = res)
      allowance(config.usdcAddress, config.mintAddress).then(res => this.usdcAllowance = res)
      allowance(config.otmAddress, config.mintAddress).then(res => this.otmAllowance = res)
      this.inputDisabled = false
      inviterMap().then(res => {
        if (ethers.BigNumber.from(res).toString() == '0') {
          if (this.urlInviterAddress) {
            this.inviter = this.urlInviterAddress
          } else {
            this.inviter = '0x1c4758DA53E00DFb70C30944e8B30E8695A84c91'
          }
        } else {
          this.inviter = res
          this.inputDisabled = true
        }
      })
    },
    buy() {
      if (!this.walletAddress) {
        this.connectWallet()
        return;
      }
      if (this.usdcBalance < this.usdcCost) {
        this.$message({
          message: 'usdc余额不足',
          type: 'warning'
        })
        return;
      }
      if (this.otmBalance < this.otmCost) {
        this.$message({
          message: 'otm余额不足',
          type: 'warning'
        })
        return;
      }
      this.dialogVisible = true
    },
    async confirmBuy() {
      if (this.buyStatus) return;
      if (this.usdcAllowance < this.usdcCost) {
        this.buyStatus = 'approving'
        try {
          const approveRes = await approve(config.usdcAddress, config.mintAddress, this.usdcCost)
          if (approveRes.status !== 1) {
            this.$message({
              message: 'USDC授权失败',
              type: 'error'
            })
            this.buyStatus = ''
            return;
          }
        } catch (e) {
          console.log('e', e)
          this.$message({
            message: 'USDC授权失败',
            type: 'error'
          })
          this.buyStatus = ''
          return;
        }
      }
      if (this.otmAllowance < this.otmCost * 2) {
        this.buyStatus = 'approving'
        try {
          const approveRes1 = await approve(config.otmAddress, config.mintAddress, this.otmCost * 2)
          if (approveRes1.status !== 1) {
            this.$message({
              message: 'OTM授权失败',
              type: 'error'
            })
            return;
          }
        } catch (e) {
          console.log('e', e)
          this.$message({
            message: 'OTM授权失败',
            type: 'error'
          })
          this.buyStatus = ''
          return;
        }
      }
      this.buyStatus = 'minting'
      setTimeout(() => this.userMint(), 3000)
    },
    userMint() {
      mint(this.buyType, this.buyAmount, this.inviter).then(res => {
        if (res.status === 1) {
          this.$message({
            message: '铸造成功',
            type: 'success'
          })
          this.init()
          this.getTokenInfo()
          this.dialogVisible = false
          this.saveHistory()
        } else {
          this.$message({
            message: '铸造失败',
            type: 'error'
          })
        }
        this.buyStatus = ''
      }).catch((e) => {
        console.log('e', e)
        this.buyStatus = ''
        this.$message({
          message: '铸造失败',
          type: 'error'
        })
      }).finally(() => this.buyStatus = '')
    },
    connectWallet() {
      if (!wallet.hasMetaMask()) {
        this.$message({
          message: this.$i18n.locale === 'zh-CN' ? '请安装 MetaMask' : 'Please install MetaMask',
          type: 'warning'
        })
        return
      }
      wallet.connectWallet().then((address) => {
        this.$store.state.walletAddress = address
        // 检查是否在 BSC 链上
        return wallet.isCorrectChain()
      }).then(function (isCorrect) {
        if (!isCorrect) {
          return wallet.switchToBSC()
        }
      }).catch(function (error) {
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    saveHistory() {
      this.storageList.push({
        createTime: formatTimes3(),
        inviter: this.inviter,
        amount: this.buyAmount,
        address: this.address
      })
      localStorage.setItem('rwabs_mint_history_v101', JSON.stringify(this.storageList))
      this.$store.state.mintTimes = this.$store.state.mintTimes + 1
    }
  }
}
</script>

<style scoped lang="scss">
@import './style.scss';
@import './h5-style.scss';
</style>
